import { useEffect } from 'react';

type ToastProps = {
  message: string;
  kind?: 'success' | 'error' | 'info';
  onClose: () => void;
};

export function Toast({ message, kind = 'info', onClose }: ToastProps) {
  useEffect(() => {
    const t = setTimeout(onClose, 4000);
    return () => clearTimeout(t);
  }, [onClose]);

  const cls =
    kind === 'success'
      ? 'bg-success-light text-success border-success/30'
      : kind === 'error'
        ? 'bg-danger-light text-danger border-danger/30'
        : 'bg-primary-50 text-primary border-primary/30';

  return (
    <div className="fixed bottom-6 right-6 z-50 reveal">
      <div className={`border rounded-lg px-4 py-3 shadow-card-hover text-sm font-medium ${cls}`}>
        {message}
      </div>
    </div>
  );
}
